e4.cart = {
    cartContent: {},
    isCleanCart: false,
    init: function () {
        if ( jQuery( '.js-e-cart-form' ).length === 1 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'loop compare compare_extended' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-cart-orderlines #js-e-handlebars-tmpl-cart-summery' );
                // ATTENTION: Please note that all product-add/remove events are trigger on jQuery( document ) and not
                // the cart element.
                e4.cart.event = e4.util.registerEvents( 'load loaded update updated productadd productadded productremove productremoved orderlinedelete orderlinedeleted orderlineincrease orderlinedecrease', 'cart' );
                e4.cart.bindEvents();
                e4.cart.orderline.init();
                e4.cart.load();
            } );
        }
        else if ( jQuery( '.js-e-cart-quantity' ).length > 0 ) {
            e4.cart.event = e4.util.registerEvents( 'productadd productadded productremove productremoved', 'cart' );
            e4.cart.updateQuantity();
            e4.cart.msg.init();
        }
    },
    handleConfigLines: {
        instances: [],
        clearLines: function () {
            Object.keys( sessionStorage ).forEach( function ( key ) {
                if ( key.indexOf( 'dcc.config.total' ) > -1 ) {
                    sessionStorage.removeItem( key );
                }
            } );
        },
        getLines: function () {
            var returnValue = [];
            Object.keys( sessionStorage ).forEach( function ( key ) {
                if ( key.indexOf( 'dcc.config.total' ) > -1 ) {
                    returnValue.push( JSON.parse( sessionStorage.getItem( key ) ) );
                }
            } );
            return returnValue;
        },
        findLines: function () {
            var configOrderlines = jQuery( '.js-e-orderline.product-orderline[data-is-config-parent="true"]' );
            e4.cart.handleConfigLines.clearLines();
            configOrderlines.each( function ( index, domOl ) {
                var olId = domOl.id,
                    jLastLine = null,
                    jServiceFeeLine = jQuery( domOl ).next( '.js-e-orderline.warranty-orderline' ),
                    jWarrentyLine = null,
                    jAutopilotLine = jQuery('.js-e-cart-orderlines').find('.autopilot-orderline').filter(function(index, autoDomEl){
                        return autoDomEl.dataset.parentId === olId;
                    });
                
                if ( jServiceFeeLine.length === 1 ) {
                    jWarrentyLine = jServiceFeeLine.nextAll( '.js-e-orderline.service-orderline' ).first();
                    if ( jWarrentyLine.length === 1 ) {
                        jLastLine = jWarrentyLine;
                    }
                    else {
                        if(jAutopilotLine.length){
                            jLastLine = jAutopilotLine;
                        } else{
                            jLastLine = jServiceFeeLine;
                            jWarrentyLine = null;
                        }
                        
                        
                    }
                    
                }
                else {
                    jWarrentyLine = jQuery( domOl ).nextAll( '.js-e-orderline.service-orderline' ).first();
                    jServiceFeeLine = null;
                    if ( jWarrentyLine.length === 1 ) {
                        jLastLine = jWarrentyLine;
                    }
                    else {
                        if(jAutopilotLine.length === 1){
                            jLastLine = jAutopilotLine;
                        }
                        jWarrentyLine = null;
                    }
                }
                
                e4.cart.handleConfigLines.buildTotalLineInCart( jQuery( domOl ), jAutopilotLine, jServiceFeeLine, jWarrentyLine, jLastLine );
            } );
        },
        buildTotalLineInCart: function ( jConfigLine, jAutopilotLine, jServiceLine, jWarrentyLine, jLastLine ) {
            if(jLastLine !== null){
                var totalPrice = 0,
                    configLineQuantity = jConfigLine.data( 'quantity' ),
                    configPrice = jConfigLine !== null ? e4.util.formatStringToJavascriptNumber( jConfigLine.data( 'price' ) ) / configLineQuantity : 0,
                    servicePrice = jServiceLine !== null ? e4.util.formatStringToJavascriptNumber( jServiceLine.data( 'price' ) ) / configLineQuantity : 0,
                    autopilotPrice = jAutopilotLine.length > 0 ? e4.util.formatStringToJavascriptNumber( jAutopilotLine.data( 'price' ) ) / configLineQuantity : 0,
                    warrentyPrice = jWarrentyLine !== null ? e4.util.formatStringToJavascriptNumber( jWarrentyLine.data( 'price' ) ) / configLineQuantity : 0;
                
                totalPrice += configPrice;
                totalPrice += servicePrice;
                totalPrice += autopilotPrice;
                totalPrice += warrentyPrice;
                var totalTmp = jQuery( '.js-config-total-tmpl' ).html(),
                    jTotalMarkup = jQuery( totalTmp );
                jTotalMarkup.find( '.js-config-total-price .e-price-price' ).html( e4.util.formatJavascriptNumberToLocaleString( totalPrice ) );
                jLastLine.after( jTotalMarkup );
                if(servicePrice > 0){
                    jServiceLine.find('.js-dcc-service-unit-price .e-price-price').html(e4.util.formatJavascriptNumberToLocaleString(servicePrice));
                }
                sessionStorage.setItem( 'dcc.config.total.' + jLastLine.attr( 'id' ), JSON.stringify( {
                    lastLineId: jLastLine.attr( 'id' ),
                    configLineId: jConfigLine.attr('id'),
                    isServiceFee: jWarrentyLine === null && jServiceLine !== null,
                    totalPrice: totalPrice
                } ) );
            }
            
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-cart-form' ).on( 'submit', function ( event ) {
            event.preventDefault();
        } );
    },
    ajax: function ( objAjaxSettings, fnCallback ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
            url: e4.settings.ecom.cart.url,
            method: 'POST',
            dataType: 'json',
            cache: false
        }, objAjaxSettings ) );
        jqXHR.done( function ( data ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( data );
            }
        } );
    },
    load: function () {
        var jCart = jQuery( '.js-e-cart' );
        jCart.trigger( e4.cart.event.load );
        e4.cart.ajax( {
            method: 'GET',
            beforeSend: function () {
                jCart.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
            }
        }, function ( data ) {
            e4.cart.updateContent( data );
            jCart.trigger( e4.cart.event.loaded );
        } );
    },
    addProduct: function ( objProductFormData, fnCallback ) {
        var jDocument = jQuery( document ),
            jCart = jDocument.find( '.js-e-cart' );
        var objProductData = {
            CartCmd: 'add',
            ProductID: '',
            VariantID: '',
            Quantity: 1,
            Redirect: false
        };
        if ( jQuery.isPlainObject( objProductFormData ) ) {
            jQuery.extend( objProductData, objProductFormData );
        }
        else if ( jQuery.type( objProductFormData ) === 'string' ) {
            objProductData.ProductID = objProductFormData;
        }
        jDocument.trigger( e4.cart.event.productadd, objProductData );
        //if ( objProductData.ProductID.indexOf( 'PROD' ) === 0 ) {
        e4.cart.ajax( {
            data: objProductData,
            beforeSend: function () {
                if ( jCart.length === 1 ) {
                    jCart.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                }
            }
        }, function ( data ) {
            if ( jCart.length === 1 ) {
                e4.cart.updateContent( data );
                jCart.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
                e4.cart.orderline.setFocus( data.cart.lastAdded[ 0 ].id );
            }
            else {
                if ( parseInt( objProductData.Quantity ) > parseInt( data.cart.lastAdded[ 0 ].stock.quantity ) ) {
                }
                //if(objProductFormData.EcomOrderLineFieldInput_HasConfiguration === 'false'){}
                e4.cart.msg.show( data );
            }
            if ( e4.cart.isCleanCart === true ) {
                e4.cart.isCleanCart = false;
                dcc.hubspot.events.newBasket( data );
            }
            else {
                dcc.hubspot.events.updatedBasket( data );
            }
            e4.cart.updateQuantity( data.cart.productQuantity );
            if ( typeof fnCallback === 'function' ) {
                fnCallback( data );
            }
            jDocument.trigger( e4.cart.event.productadded, objProductData );
        } );
        //}
    },
    removeProduct: function ( orderlineKey ) {
        var jDocument = jQuery( document );
        jDocument.trigger( e4.cart.event.productremove );
        var orderlineToRemove = e4.cart.cartContent.cart.orderlines.filter( function ( orderline ) {
                return orderline.id === orderlineKey;
            } ),
            trackingObj = {};
        if ( orderlineToRemove.length ) {
            trackingObj = {
                CurrencyCode: orderlineToRemove[ 0 ].product.currencyCode,
                Name: orderlineToRemove[ 0 ].product.name,
                Number: orderlineToRemove[ 0 ].product.number,
                Price: orderlineToRemove[ 0 ].product.priceClean,
                Quantity: orderlineToRemove[ 0 ].product.quantity
            };
            jDocument.trigger( e4.cart.event.productremoved, trackingObj );
        }
    },
    updateContent: function ( data ) {
        var jCart = jQuery( '.js-e-cart' );
        e4.cart.cartContent = data;
        jCart.trigger( e4.cart.event.update );
        jQuery( '.js-e-cart-orderlines' ).html( e4.handlebars.tmpl.cartOrderlines( data ) );
        e4.loading.resolveWait( '.js-e-cart-orderlines' );
        jQuery( '.js-e-cart-summery' ).html( e4.handlebars.tmpl.cartSummery( data ) );
        e4.loading.resolveWait( '.js-e-cart-summery' );
        e4.cart.updateQuantity( data.cart.productQuantity );
        e4.cart.removeStrayWarrantyLines();
        e4.cart.handleConfigLines.findLines();
        //e4.cart.removeStrayWarrentyLines();
        jCart.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
        jCart.trigger( e4.cart.event.updated );
    },
    removeStrayWarrantyLines: function(){
        var warrentyLines = jQuery('.js-e-orderline.service-orderline');

        jQuery.each(warrentyLines, function(index, domLine){
            var parentOrderlineId = domLine.dataset.parentId;
            var jParentOrderline = jQuery('.js-e-orderline.product-orderline[data-product="'+parentOrderlineId+'"]');
            if(jParentOrderline.length === 0){
                e4.cart.orderline.deleteWarrantyLine(domLine.id); 
            }
        });
    },
    updateQuantity: function ( intQuantity ) {
        if ( e4.cart.isQuantityValid( intQuantity ) === false ) {
            e4.cart.ajax( {
                method: 'GET'
            }, function ( data ) {
                if ( e4.cart.isQuantityValid( data.cart.productQuantity ) === true ) {
                    e4.cart.updateQuantity( data.cart.productQuantity );
                }
            } );
        }
        else if ( intQuantity === 0 ) {
            e4.cart.isCleanCart = true;
            jQuery( '.js-e-cart-quantity' ).html( '' );
        }
        else {
            jQuery( '.js-e-cart-quantity' ).html( intQuantity );
        }
    },
    isQuantityValid: function ( intQuantity ) {
        return isNaN( parseInt( intQuantity ) ) === false;
    },
    orderline: {
        init: function () {
            e4.cart.orderline.bindEvents();
        },
        bindEvents: function () {
            e4.cart.orderline.updateTimeout = null;
            jQuery( '.js-e-cart-form' )
                .on( 'focus blur', '.js-e-orderline-quantity', e4.cart.orderline.toggleFocus )
                .on( 'input', '.js-e-orderline-quantity', e4.util.debounce( e4.cart.orderline.onInput, e4.settings.ecom.cart.debounceDelay ) )
                .on( 'click', '.js-e-orderline-update', function ( event ) {
                    event.preventDefault();
                    e4.cart.orderline.update( this );
                } )
                .on( 'click', '.js-e-orderline-delete', function ( event ) {
                    event.preventDefault();
                    e4.cart.orderline.delete( this );
                } );
        },
        toggleFocus: function ( event ) {
            var jOrderline = jQuery( event.target ).closest( '.js-e-orderline' );
            if ( event.type === 'focusin' ) {
                jQuery( event.target ).select();
                jOrderline.addClass( 'has-focus' );
            }
            else {
                jOrderline.removeClass( 'has-focus' );
            }
        },
        onInput: function ( event ) {
            if ( parseInt( event.target.value ) !== 0 && event.target.value !== '' ) {
                e4.cart.orderline.update( event.target );
            }
        },
        update: function ( domElm ) {
            var jCart = jQuery( '.js-e-cart' ),
                jForm = jQuery( domElm ).closest( '.js-e-cart-form' ),
                jOrderline = jQuery( domElm ).closest( '.js-e-orderline' ),
                intOrderlineQuantity = parseInt( jOrderline.find( '.js-e-orderline-quantity' ).val() ),
                strOrderlineProductId = jOrderline.find( '.js-e-orderline-quantity' ).data( 'productId' ),
                intOrderlineQuantityOriginal = parseInt( jOrderline.data( 'product-quantity' ) ),
                boolHasConfiguration = jOrderline.find( '.js-e-orderline-quantity' ).data( 'hasConfiguration' );
            if ( boolHasConfiguration === true ) {
                jQuery( '.service-orderline' ).each( function ( index, domElm ) {
                    var quantityElm = jQuery( domElm ).find( '.js-e-orderline-quantity' );
                    if ( quantityElm.data( 'productId' ) === strOrderlineProductId ) {
                        quantityElm.val( intOrderlineQuantity );
                    }
                } );
            }
            if ( intOrderlineQuantity !== 0 ) {
                if ( intOrderlineQuantity > intOrderlineQuantityOriginal ) {
                    jCart.trigger( e4.cart.event.orderlineincrease );
                }
                else if ( intOrderlineQuantity < intOrderlineQuantityOriginal ) {
                    jCart.trigger( e4.cart.event.orderlinedecrease );
                }
                jForm.find( '.js-e-cart-form-cartcmd' ).val( 'updateorderlines' );
                e4.cart.ajax( {
                    data: jForm.serialize(),
                    beforeSend: function () {
                        jCart.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                    }
                }, function ( data ) {
                    e4.cart.updateContent( data );
                    dcc.hubspot.events.updatedBasket( data );
                    jCart.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
                    e4.cart.orderline.setFocus( jOrderline.attr( 'id' ) );
                } );
            }
            else {
                e4.cart.orderline.delete( domElm );
            }
        },
        delete: function ( domElm ) {
            var jCart = jQuery( '.js-e-cart' ),
                orderlineKey = jQuery( domElm ).closest( '.js-e-orderline' ).attr( 'id' ),
                productId = jQuery( domElm ).closest( '.js-e-orderline' ).data( 'product' );
            jCart.trigger( e4.cart.event.orderlinedelete );
            e4.cart.removeProduct( orderlineKey );
            e4.cart.ajax( {
                data: {
                    key: orderlineKey,
                    CartCmd: 'delorderline',
                    Redirect: false
                }
            }, function ( data ) {
                var warrantyOrderline = data.cart.orderlines.filter( function ( orderline ) {
                    return orderline.product.orderlineFields.Warranty_Parent_Product === productId;
                } );
                if ( warrantyOrderline.length > 0 ) {
                    var warrantyOrderlineKey = warrantyOrderline[ 0 ].id;
                    e4.cart.orderline.deleteWarrantyLine(warrantyOrderlineKey);
                }
                else {
                    jCart.trigger( e4.cart.event.orderlinedeleted );
                    e4.cart.updateContent( data );
                }
            } );
        },
        deleteWarrantyLine: function(warrantyOrderlineKey){
            var jCart = jQuery( '.js-e-cart' );
            e4.cart.ajax( {
                data: {
                    key: warrantyOrderlineKey,
                    CartCmd: 'delorderline',
                    Redirect: false
                }
            }, function ( data ) {
                jCart.trigger( e4.cart.event.orderlinedeleted );
                e4.cart.updateContent( data );
            } );
        },
        setFocus: function ( strIdentifier ) {
            var jOrderline = jQuery( '.js-e-orderline' ).filter( '#' + strIdentifier + ',[data-product-id="' + strIdentifier + '"]' );
            if ( jOrderline.length === 1 ) {
                jOrderline.find( '.js-e-orderline-quantity' ).focus();
            }
        }
    },
    msg: {
        timeout: null,
        init: function () {
            if ( jQuery( '#js-e-cart-msg' ).length === 1 && jQuery( '.js-e-product-form, .js-e-productlist' ).length > 0 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-cart-msg-lastadded' );
                } );
                e4.cart.msg.bindEvents();
            }
        },
        bindEvents: function () {
            var jBody = jQuery( 'body' );
            jQuery( '#js-e-cart-msg' ).on( 'show.bs.modal', function () {
                jBody.addClass( 'modal-open-no-adjustment' );
            } ).on( 'hidden.bs.modal', function () {
                jBody.removeClass( 'modal-open-no-adjustment' );
            } ).on( 'click', function ( event ) {
                if ( jQuery( event.target ).is( '#js-e-cart-msg' ) === true ) {
                    e4.cart.msg.hide();
                }
            } ).find( '.modal-dialog' ).on( 'mouseenter', e4.cart.msg.clearTimeout ).on( 'mouseleave', e4.cart.msg.setTimeout );
        },
        show: function ( data, isConfiguration ) {
            var jCartMsg = jQuery( '#js-e-cart-msg' );
            //TODO: Lav set content, header og footer funktioner.
            data.isConfiguration = isConfiguration || false;
            jCartMsg.find( '.js-e-cart-msg-content' ).html( e4.handlebars.tmpl.cartMsgLastadded( data ) );
            e4.cart.msg.clearTimeout();
            e4.cart.msg.setPosition();
            jCartMsg.modal( 'show' );
            e4.cart.msg.setTimeout();
        },
        hide: function () {
            e4.cart.msg.clearTimeout();
            jQuery( '#js-e-cart-msg' ).modal( 'hide' );
        },
        setPosition: function ( objPosition ) {
            var jCartMsgDialog = jQuery( '#js-e-cart-msg' ).find( '.modal-dialog' ),
                jHeader = jQuery( '.js-e-header' ),
                jNavItemCart = jHeader.find( '.js-e-nav-item-cart' ).filter( ':visible' ),
                objCartMsgPosition = objPosition || {},
                objCartMsgReferencePosition = {};
            if ( jCartMsgDialog.length === 1 ) {
                if ( jQuery.isEmptyObject( objCartMsgPosition ) === true ) {
                    if ( jNavItemCart.length === 1 ) {
                        objCartMsgReferencePosition = jNavItemCart.get( 0 ).getBoundingClientRect();
                        objCartMsgPosition = {
                            top: jHeader.hasClass( 'is-hidden' ) === true ? '' : Math.floor( objCartMsgReferencePosition.bottom ),
                            right: Math.floor( jQuery( window ).width() - objCartMsgReferencePosition.right ),
                            left: '',
                            maxWidth: ''
                        };
                    }
                    else {
                        objCartMsgReferencePosition = jHeader.get( 0 ).getBoundingClientRect();
                        objCartMsgPosition = {
                            top: jHeader.hasClass( 'is-hidden' ) === true ? '' : Math.floor( objCartMsgReferencePosition.bottom ),
                            right: 0,
                            left: 0,
                            maxWidth: '100%'
                        };
                    }
                }
            }
            jCartMsgDialog.css( objCartMsgPosition );
        },
        setTimeout: function () {
            e4.cart.msg.clearTimeout();
            e4.cart.msg.timeout = setTimeout( e4.cart.msg.hide, e4.settings.ecom.cart.msgHideDelay );
        },
        clearTimeout: function () {
            if ( e4.cart.msg.timeout ) {
                e4.cart.msg.timeout = clearTimeout( e4.cart.msg.timeout );
            }
        }
    }
};

